import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import { de_DE } from "@fancyapps/ui/dist/fancybox/l10n/de_DE.js";
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

gsap.registerPlugin(ScrollTrigger, CustomEase);

const body = document.querySelector('body');

export async function ajaxWrapper(parameters = {}) {
  const data = new FormData();

  for (const key in parameters) {
    data.append(key, parameters[key]);
  }

  const elem = document.querySelector('body');

  let response = [

  ];

  try {
    response = await fetch(
      elem.classList.contains('wp-admin') ? ajaxurl : localized.ajaxUrl,
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
        },
        body: data,
      },
    );
  }
  catch (e) {
    console.log(e.message);
  }

  return response.json();
}

export async function dummyAjaxCall(var1, var2) {
  const ajaxLocalized = ajaxDummyAjax;

  const response = await ajaxWrapper({
    'action': ajaxLocalized.action,
    'security': ajaxLocalized.nonce,
    'var1': var1,
    'var2': var2,
  });

  if (response.success === false) {
    console.error(response);
    return;
  }

  console.log(response);
}

export async function handleNewsletterForm() {
  const form = document.getElementById('footer-newsletter');

  if (!form) {
    return;
  }

  form.addEventListener('mouseover', event => {
    const target = event?.target?.closest?.('em');

    if (!target) {
      return;
    }

    if (!target.classList.contains('hover-active')) {
      for (const error_element of form.querySelectorAll('em, em span.error')) {
        error_element.classList.remove('hover-active');
      }

      for (const error_span of target.querySelectorAll('span.error')) {
        error_span.classList.add('hover-active');
      }

      target.classList.add('hover-active');
    }
  });

  form.addEventListener('mouseout', event => {
    const target = event?.target?.closest?.('em');

    if (!target) {
      return;
    }

    for (const error_element of form.querySelectorAll('em, em span.error')) {
      error_element.classList.remove('hover-active');
    }
  });

  jQuery(form).validate({
			errorElement: 'span',
			wrapper: 'em',
			highlight: (element, error_class, valid_class) => {
				jQuery(element).addClass(error_class).removeClass(valid_class);
			},
			submitHandler: async () => {

			}
		});
}

export async function initReviewsSlider() {
  const swiper = new Swiper("#reviews-slider", {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      keyboard: {
        enabled: true,
      },
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
        pauseOnMouseEnter: true
      },
      breakpoints: {
        991: {
          slidesPerView: 2,
        },
        1199: {
          slidesPerView: 3,
        },
      },
    });
}

const freezeBody = () => {
    body.style.overflow = 'hidden';
}

const releaseBody = () => {
    body.style.overflow = 'hidden auto';
}

export const initAccordions = () => {
  const titleWrappers = document.querySelectorAll('.fca-title-wrapper');

  const setAccordionHeight = (contentWrapper, accordionRow) => {
    if (accordionRow.dataset.state === 'active') {
      contentWrapper.style.maxHeight = contentWrapper.scrollHeight + "px";
    } else {
      contentWrapper.style.maxHeight = null;
    }
  };

  const getAccordionElements = (titleWrapper) => {
    const contentWrapper = titleWrapper.nextElementSibling;
    const accordionRow = contentWrapper?.closest('.fca-row');
    return { contentWrapper, accordionRow };
  };

  const updateAccordionHeights = () => {
    titleWrappers.forEach(titleWrapper => {
      const { contentWrapper, accordionRow } = getAccordionElements(titleWrapper);

      if (contentWrapper && accordionRow && accordionRow.dataset.state === 'active') {
        setAccordionHeight(contentWrapper, accordionRow);
      }
    });
  };

  titleWrappers.forEach(titleWrapper => {
    titleWrapper.addEventListener('click', function() {
      const { contentWrapper, accordionRow } = getAccordionElements(this);

      if (!contentWrapper) {
        return;
      }

      accordionRow.dataset.state = accordionRow.dataset.state === 'active' ? 'inactive' : 'active';
      setAccordionHeight(contentWrapper, accordionRow);
    });
  });

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      updateAccordionHeights();
    }, 200);
  });
}

export const handleFancybox = () => {
  let fancybox_settings = {
    hideScrollbar: true,
    Carousel: {
      formatCaption: (carouselRef, slide) => {
        if (slide.triggerEl) {
            const wpCaption = slide.triggerEl.closest('.wp-caption');

            if (wpCaption) {
              const captionText = wpCaption.querySelector('.wp-caption-text');
              if (captionText) {
                return captionText.textContent.trim();
              }
            }
        }
      },
    }
  };

  switch (localized.locale) {
    case 'de':
      fancybox_settings['l10n'] = de_DE;
      break;
  }

  Fancybox.bind(".open-in-modal", fancybox_settings);

  Fancybox.getDefaults().Hash = false;
}

export const handleMenu = () => {
  CustomEase.create(
    "hop",
    "M0,0 C0.354,0 0.464,0.133 0.498,0.502 0.532,0.872 0.651,1 1,1"
  );

  const body = document.querySelector('body');
  const menuToggle = document.getElementById("burger-button");
  const menu = document.getElementById("main-menu");
  const header_menu_links = menu.querySelectorAll(".header-menu .menu-item");
  const menu_cta_button = menu.querySelector('.cta-button');

  let isAnimating = false;

  menuToggle.addEventListener("click", () => {
    if (isAnimating) return;

    if (!body.classList.contains("mm-active")) {
      body.classList.add("mm-active");
      freezeBody();
      menuToggle.setAttribute("aria-expanded", "true");

      isAnimating = true;

      gsap.to(menu, {
        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
        ease: "hop",
        duration: 1.5,
        onStart: () => {
          menu.style.pointerEvents = "all";
        },
        onComplete: () => {
          isAnimating = false;
        },
      });

      gsap.to(menu_cta_button, {
        y: 0,
        opacity: 1,
        stagger: 0.1,
        delay: 0.85,
        duration: 1,
        ease: "power3.out",
      });

      gsap.to(header_menu_links, {
        y: 0,
        opacity: 1,
        stagger: 0.1,
        delay: 0.85,
        duration: 1,
        ease: "power3.out",
      });
    } else {
      body.classList.remove("mm-active");
      releaseBody();
      menuToggle.setAttribute("aria-expanded", "false");

      isAnimating = true;

      gsap.to(menu, {
        clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
        ease: "hop",
        duration: 1.5,
        onComplete: () => {
          menu.style.pointerEvents = "none";
          gsap.set(menu, {
            clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
          });

          gsap.set(menu_cta_button, { y: 30, opacity: 0 });
          gsap.set(header_menu_links, { y: 30, opacity: 0 });

          isAnimating = false;
        },
      });
    }
  });
}

export const animateWhenVisible = (elem, animation) => {
    if (document.querySelector(elem) === null) {
      return;
    }

    const fromY = animation === 'top-to-bottom' ? -50 : animation === 'none' ? 0 : 50;

    gsap.set(elem, {
        y: fromY,
        autoAlpha: 0,
        force3D: true
    });

    ScrollTrigger.batch(elem, {
        batchMax: 10,
        once: true,
        onEnter: (elements) => {
            gsap.to(elements, {
                autoAlpha: 1,
                y: 0,
                duration: 1,
                ease: "power1.out",
                stagger: { each: 0.1 },
                overwrite: true
            });
        }
    });
}
